// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DeliveryNoteVm from "../../../../../edit-order/view/view-model/DeliveryNoteVm.bs.js";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as NLOrderDeliveryNoteVm from "./vm-mapper/NLOrderDeliveryNoteVm.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(delivery_note, dn_label) {
  return {
          hd: {
            label: dn_label + " requested",
            value: {
              TAG: /* Text */0,
              _0: delivery_note.is_requested
            }
          },
          tl: {
            hd: {
              label: dn_label + " Status",
              value: {
                TAG: /* Text */0,
                _0: delivery_note.status
              }
            },
            tl: /* [] */0
          }
        };
}

function NLOrderDeliveryNote(Props) {
  var order = Props.order;
  var delivery_note = NLOrderDeliveryNoteVm.getVm(order);
  var country = CountryContext.useContext(undefined).country;
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: DeliveryNoteVm.getDNNameCaps(country) + " Information"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(delivery_note, DeliveryNoteVm.getDNName(country)))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderDeliveryNote;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
